const SESSION_LIMIT = 12 * 60 * 60 * 1000; // 12 hours


/* Get Session */

export function getSession() {

  try {

    const session = JSON.parse(
      sessionStorage.getItem("session")
    );

    if (!session) return null;

    const now = Date.now();

    /* Check session expiry */

    if (now - session.loginTime > SESSION_LIMIT) {

      clearSession();
      return null;

    }

    return session;

  } catch (err) {

    console.error("Session parse error", err);
    clearSession();
    return null;

  }

}


/* Save Session */

export function setSession(data) {

  const sessionData = {
    ...data,
    loginTime: Date.now()
  };

  sessionStorage.setItem(
    "session",
    JSON.stringify(sessionData)
  );

}


/* Clear Session */

export function clearSession() {

  sessionStorage.clear();

  if (window.location.pathname !== "/login") {
    window.location = "/login";
  }

}